import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names and lets a later one win over an earlier one.
 *
 * What shadcn components call `cn`. `clsx` handles the conditionals; `tailwind-merge` resolves the
 * conflicts — without it a component's own `px-4` and a caller's `px-6` both land in the class list and
 * the winner is whichever Tailwind happened to emit first in the stylesheet, which is not something a
 * caller can reason about.
 *
 * Placed in `shared/lib` rather than shadcn's default `lib/utils`, because §4 has no `lib/utils` and a
 * file called `utils` becomes the drawer everything unrelated ends up in. `components.json` points the
 * generator here.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
